import { trackCustomSnowplowEvent } from "./snowplowEventTrackers";
import { createClubContext, createUiInteractionPrimaryEvent } from "./snowplowTracking";

/**
 * Tracks a UI interaction event with club context
 * @param {object} params - Parameters for tracking
 * @param {object} params.clubData - Club object containing club data
 * @param {string} params.element_name - Name or ID of the UI element (button/link)
 * @param {'click'|'tap'|'hover'|'scroll'|'swipe'|'drag'|'long_press'} params.interaction_type - Type of UI interaction
 * @param {string} [params.element_type] - Type of UI element (e.g., button, image, link, card)
 * @param {string} [params.element_position] - Position of the element in the UI
 */
export function trackClubInteraction({
    clubData = {},
    element_name,
    interaction_type,
    element_type,
    element_position
}) {
    const clubContext = createClubContext({
        club_id: clubData.id || clubData.club_id || clubData.teamId,
        club_name: clubData.name || clubData.club_name || clubData.teamName,
        club_city: clubData.city || clubData.club_city || clubData.location
    });

    const uiInteractionEvent = createUiInteractionPrimaryEvent({
        element_name,
        interaction_type,
        element_type,
        element_position
    });

    const contexts = clubContext ? [clubContext] : [];
    trackCustomSnowplowEvent(uiInteractionEvent, contexts);
}

export function trackClubClick({
    clubData,
    element_name,
    element_type,
    element_position
}) {
    return trackClubInteraction({
        clubData,
        element_name,
        interaction_type: 'click',
        element_type,
        element_position
    });
}